module.exports = __webpack_public_path__ + "static/media/blurred-background.c905af10.png";